/**
 * Ekibe katılma (Faz 2 akışı, katalog s. 19).
 *
 * Davet e-postasındaki bağlantı: https://…/?join=<token>
 *   1. Açılışta token adres çubuğundan alınır ve oturum deposuna konur
 *      (geçmişe/ekran görüntüsüne düşmesin).
 *   2. Giriş ekranında önizleme: hangi ofis, hangi rol, maskeli e-posta
 *      (preview_staff_invite — girişsiz çağrılabilir, başka bir şey döndürmez).
 *   3. "Customer / firm" sorusu gösterilmez (katalog s. 5): davet geçerliyse taraf
 *      firm olarak seçilir, geri dönüş düğmesi gizlenir; kişi davet edilen
 *      e-postayla giriş yapar ya da kayıt olur. Kural yine veritabanında.
 *   4. Girişten sonra accept_staff_invite. E-posta eşleşmesi, doğrulanmış
 *      e-posta, müşteri hesabı olmama kuralları veritabanında.
 */

import { defineFeature } from '../../shell/feature.ts';
import { legacy } from '../../shell/bridge.ts';

const KEY = 'tekoffice.joinToken';

function el(id: string): HTMLElement | null { return document.getElementById(id); }
function esc(s: unknown): string { return legacy.escapeHtml(String(s ?? '')); }

function takeToken(): string | null {
  try {
    const url = new URL(location.href);
    const t = url.searchParams.get('join');
    if (t) {
      sessionStorage.setItem(KEY, t);
      url.searchParams.delete('join');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
    return sessionStorage.getItem(KEY);
  } catch { return null; }
}

async function banner(token: string): Promise<void> {
  for (let i = 0; i < 40 && !legacy.sb; i++) await new Promise((r) => setTimeout(r, 250));
  const sb = legacy.sb;
  const ls = el('ls');
  if (!sb || !ls) return;
  const r = await sb.rpc('preview_staff_invite', { p_token: token });
  const d = r && r.data;
  const box = document.createElement('div');
  box.id = 'tj-banner';
  box.style.cssText = 'position:absolute;top:16px;left:50%;transform:translateX(-50%);z-index:20;max-width:420px;width:calc(100% - 32px);'
    + 'background:#141414;border:1px solid #333;border-radius:14px;padding:12px 14px;font-size:12px;color:#ddd;line-height:1.6';
  box.innerHTML = d && d.ok
    ? `<b>${esc(d.firm_name)}</b> invited you to join their team as <b>${esc(d.role)}</b>.<br>`
      + `Sign in or create an account with <b translate="no">${esc(d.email_masked)}</b>.`
    : `<span style="color:#ff6b6b">${esc((d && d.error) || 'This invitation is no longer valid.')}</span>`;
  if (!(d && d.ok)) { try { sessionStorage.removeItem(KEY); } catch { /* sessiz */ } }
  el('tj-banner')?.remove();
  ls.appendChild(box);
  if (d && d.ok) {
    const g = globalThis as any;
    g.chooseAccountType?.('firm');
    const back = el('role-back-btn');
    if (back) back.style.display = 'none';
  }
}

async function accept(): Promise<void> {
  let token: string | null = null;
  try { token = sessionStorage.getItem(KEY); } catch { /* sessiz */ }
  if (!token || !legacy.sb) return;
  const r = await legacy.sb.rpc('accept_staff_invite', { p_token: token });
  const d = r && r.data;
  try { sessionStorage.removeItem(KEY); } catch { /* sessiz */ }
  el('tj-banner')?.remove();
  legacy.toast(d && d.ok ? 'You joined the team. Your clients appear under “My clients”.' : ((d && d.error) || 'The invitation could not be accepted.'));
}

export default defineFeature({
  id: 'team-join',
  label: 'Ekibe katılma',
  view: null,
  boot: () => {
    const t = takeToken();
    if (t) void banner(t);
  },
  legacyGlobals: {
    tjAccept: () => accept(),
  },
});
